'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/shim');

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _getFeatureFlags = require('ifeis-isomorphic/lib/redux/actions/feature-flags/getFeatureFlags');

require('angular-audio/app/angular.audio.js');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _table = require('./table');

var _table2 = _interopRequireDefault(_table);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _session = require('./session');

var _session2 = _interopRequireDefault(_session);

var _feiseanna = require('./feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _stripe = require('./stripe');

var _stripe2 = _interopRequireDefault(_stripe);

var _common = require('./common/common.module');

var _common2 = _interopRequireDefault(_common);

var _redux = require('redux');

var _reduxSocket = require('redux-socket.io');

var _reduxSocket2 = _interopRequireDefault(_reduxSocket);

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

var _reduxLogger = require('redux-logger');

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

require('ng-redux');

var _middleware = require('./middleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainNavController = function () {
  function MainNavController($scope, $window, $mdSidenav, fSession, fFeisService, $state, msgService, $ngRedux) {
    var _this = this;

    _classCallCheck(this, MainNavController);

    this._ = { $window: $window, $mdSidenav: $mdSidenav, fFeisService: fFeisService, $state: $state, msgService: msgService, fSession: fSession };
    this.fSession = fSession;
    $scope.$on('feisAdded', function () {
      return _this.loadFeiseannaForUser();
    });
    this.loadFeiseannaForUser();

    $ngRedux.dispatch((0, _getFeatureFlags.getFeatureFlags)()).then(function (response) {
      _this.isCrossNavigationEnabled = !!(response.payload && response.payload.flags.isCrossNavigationEnabled);
    });
  }

  _createClass(MainNavController, [{
    key: 'close',
    value: function close() {
      this._.$mdSidenav('left').close();
    }
  }, {
    key: 'loadFeiseannaForUser',
    value: function loadFeiseannaForUser() {
      var _this2 = this;

      this.fSession.user().then(function () {
        _this2._.fFeisService.mine().then(function (feiseanna) {
          return _this2.feiseanna = feiseanna;
        }, function (err) {
          return _this2._.msgService.displayErrorMsg(err);
        });
      }, function (err) {
        return _this2._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'go',
    value: function go(state, params, $event) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }

      this._.$state.go(state, params);
      this.close();
    }
  }, {
    key: 'goToExternalUrl',
    value: function goToExternalUrl(path, id, slug) {
      if (!path) return;
      var url = IFEIS_APPV2_URI + '/' + path;
      if (id && slug) {
        url = url + '/' + id + '/' + slug;
      }
      window.location.href = url;
    }
  }]);

  return MainNavController;
}();

exports.default = angular.module('ifeis', ['ifeis.stripe', 'ngAria', 'ngMaterial', 'ngSanitize', 'ngMessages', 'ngAnimate', 'ngRedux', 'jdm.material', 'ngAudio', 'ifeis.routes', 'ifeis.session', 'ifeis.feiseanna', 'ifeis.common', require('angular-credit-cards')]).factory('callApiMiddleware', _middleware.callApiMiddleware).config(function ($httpProvider, $mdThemingProvider, $ngReduxProvider) {
  /**
   * DRY: Transform standard server responses.
   */
  $httpProvider.interceptors.push(function ($q) {
    return {
      'response': function response(_response) {
        if (!angular.isObject(_response.data)) {
          return _response;
        } else if (_response.data.errors) {
          return $q.reject(_response.data.errors);
        } else if (_response.data.data !== undefined) {
          return _response.data.data;
        } else {
          console.error("Unknown routing error", _response);
          return $q.reject('Unknown error');
        }
      }
    };
  });

  /**
   * Set standard ngMaterial palettes.
   */
  $mdThemingProvider.theme('default').primaryPalette('green').accentPalette('deep-orange');

  $mdThemingProvider.theme('ifeis-dark').primaryPalette('lime');

  $mdThemingProvider.theme('secondary').primaryPalette('blue-grey').accentPalette('green');

  $mdThemingProvider.theme('teal').primaryPalette('teal').accentPalette('teal');

  /**
   * Configure the Redux Store.
   */
  var logger = (0, _reduxLogger2.default)({
    collapsed: true
  });

  var socket = (0, _socket2.default)(IFEIS_API_URI, { transports: ["websocket"] });
  var socketIoMiddleware = (0, _reduxSocket2.default)(socket, "/SOCKET_");

  $ngReduxProvider.createStoreWith(_ifeisIsomorphic.MainReducer, [_reduxThunk2.default, 'callApiMiddleware', logger, socketIoMiddleware]);
}).run(function ($timeout, $rootScope, $mdSidenav, $window, $document, $ngRedux) {
  (function bootstrapFromAppv2Url() {
    try {
      var params = new URLSearchParams(window.location.search);
      var urlToken = params.get('token');
      if (!urlToken) return;
      var urlFname = params.get('firstName');
      var urlLname = params.get('lastName');
      var urlUserId = params.get('userId');
      params.delete('token');
      params.delete('firstName');
      params.delete('lastName');
      params.delete('userId');
      var cleanSearch = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (cleanSearch ? '?' + cleanSearch : ''));
      localStorage.setItem('jwt', JSON.stringify({ token: urlToken }));
      if (urlFname) localStorage.setItem('firstName', urlFname);
      if (urlLname) localStorage.setItem('lastName', urlLname);
      if (urlUserId) localStorage.setItem('userId', urlUserId);
    } catch (e) {}
  })();

  $window.ngReduxStore = $ngRedux;

  // Get LiveAgent widget DOM element
  var liveAgentWgt = void 0;
  (function checkLiveAgentLoaded() {
    if ($window.LiveAgent) {
      liveAgentWgt = angular.element(document.getElementById('f-liveagent-contact')).next();
    } else {
      $timeout(function () {
        checkLiveAgentLoaded();
      }, 100);
    }
  })();

  $window.FB.init({
    appId: FACEBOOK_CLIENT_ID,
    xfbml: true,
    version: 'v2.8'
  });
  $window.FB.AppEvents.logPageView();

  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    // Hide the LiveAgent element
    // on managers pages
    if (liveAgentWgt) {
      if (toState.name.match(/(feiseanna)/) && toState.name.match(/(admin|stages|syllabus|personnel|adjudicators|schedule|reports|finance|registration|dashboard|tabulations|printed-placements|announce|results|manager|scores|finalize|review)/)) {
        liveAgentWgt.addClass('f-hidden');
      } else if (toState.name.match(/(admin)/) && toState.name.match(/(dashboard|trainings|invitations|schools|adjudicators|edit-accounts)/)) {
        liveAgentWgt.addClass('f-hidden');
      } else {
        liveAgentWgt.removeClass('f-hidden');
      }
    }
  });

  // Hide the page loading mask. This must happen in at least the second digest for the animation to
  // show, so we do it after an inconsequential delay.
  $timeout(function () {
    return $rootScope.pageLoaded = true;
  }, 10);

  // Keep track of the previous state
  // to be able to navigate back in state history
  $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
    $rootScope.previousState = from.name;
  });
}).controller('MainNavController', MainNavController).value('config', _ifeisIsomorphic.Config);


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 484
// module chunks = 0